import {
  ComplaintsNotesDocument,
  UpdateComplaintsNoteDocument,
  UpdateComplaintsNoteMutation,
  UpdateComplaintsNoteMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateComplaintsNote = () => {
  const [executeMutation, { loading }] = useMutation(UpdateComplaintsNoteDocument, {
    extractorFn: (data: UpdateComplaintsNoteMutation) =>
      data.complaintsMutations.updateComplaintsNote,
  })

  const updateComplaintsNote = async (variables: UpdateComplaintsNoteMutationVariables) => {
    return executeMutation({
      variables,
      refetchQueries: [ComplaintsNotesDocument],
      awaitRefetchQueries: true,
    })
  }

  return {
    updateComplaintsNote,
    loading,
  }
}
